import { AlertCircle } from "lucide-react";
import { getErrorCount } from "@utils/utils";
import type { FieldErrors } from "react-hook-form";

interface FormErrorSummaryProps {
  errors: FieldErrors;
  showScrollHint?: boolean;
  className?: string;
}

/**
 * Displays a summary of form validation errors with an error count
 * @param errors - Form errors from react-hook-form
 * @param showScrollHint - Whether to show a hint to scroll up to fix errors (default: true)
 * @param className - Additional CSS classes for styling
 */
export const FormErrorSummary = ({ errors, showScrollHint = true, className = "" }: FormErrorSummaryProps) => {
  const errorCount = getErrorCount(errors);

  if (errorCount === 0) return null;

  return (
    <div className={`flex flex-col items-start text-sm text-red-500 ${className}`}>
      <div className="flex items-center">
        <AlertCircle className="mr-2 size-4" />
        <span>
          {errorCount} erreur{errorCount > 1 ? "s" : ""} à corriger
        </span>
      </div>
      {showScrollHint && <span className="ml-6">Remonter dans le formulaire pour corriger les erreurs</span>}
    </div>
  );
};
